import { render, staticRenderFns } from "./_IbxItemsToolbar.vue?vue&type=template&id=42da793b"
import script from "./_IbxItemsToolbar.vue?vue&type=script&lang=js"
export * from "./_IbxItemsToolbar.vue?vue&type=script&lang=js"
import style0 from "./_IbxItemsToolbar.vue?vue&type=style&index=0&id=42da793b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports